import { AxiosError } from 'axios'
import { useMutation } from '@tanstack/react-query'
import useWbapiInstance from './useWbapiInstance'

interface CreateTicketCommand {
  subject: string
  type: string
  requestorEmail: string
  notes: string
}

export default function useFreshService() {
  const { api } = useWbapiInstance()

  return useMutation<Number, AxiosError, CreateTicketCommand>({
    mutationFn: (request) => api.post(`/api/v1/tickets`, request).then((resp) => resp.data),
  })
}
